import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Foundation from "@/pages/Foundation";

export const Route = createFileRoute("/zh-cn/about-qbd/qbd-group-foundation")({
  head: () => buildRouteHead("/zh-cn/about-qbd/qbd-group-foundation"),
  component: Foundation,
});

